<template>
  <v-container>
    <div
      v-if="loading"
      :style="styleObject"
      class="text-center"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div
      v-else
    >
      <div
        id="idTable"
        style="overflow-x: auto; max-width: 100%;"
      >
        <table
          style="width: 100%; color: black; border-collapse: collapse;"
          class="elevation-1"
        >
          <thead>
            <tr>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                class="black--text title"
              >
                Categoria
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                class="black--text title"
              >
                Subcategoria
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                class="black--text title"
              >
                Total
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                class="black--text title"
              >
                Recebido
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                class="black--text title"
              >
                Em aberto
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in dadosDetalhamento"
              :key="item.id"
              style="cursor: pointer;"
            >
              <td
                id="dadoMovimentacao"
                style="text-align: left;"
              >
                {{ item.categoria }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: left;"
              >
                {{ item.subcategoria }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.total }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
                :style="styleObjectValorPago"
              >
                {{ item.pago }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.aberto }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
  import ContasReceber from '../../../../../../services/contasreceber'
  import eventEmit from '../../../core/EventoEmit'

  export default {
    name: 'ShowSaldoTotal',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectValorPago: {
        color: '#4780b8',
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      selectClientes: [],
      headersDetalhamento: [
        { text: 'Categoria', value: 'categoria', width: '300px', class: 'black--text title' },
        { text: 'Subcategoria', value: 'subcategoria', width: '200px', align: 'right', class: 'black--text title' },
        { text: 'Total', value: 'total', width: '200px', align: 'right', class: 'black--text title' },
        { text: 'Recebido', value: 'pago', width: '200px', align: 'right', class: 'black--text title' },
        { text: 'Em aberto', value: 'aberto', width: '200px', align: 'right', class: 'black--text title' },
      ],
      dadosDetalhamento: [],
    }),

    created () {
      eventEmit.$on('set-dados-detalhamento-contas-a-Receber', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-dados-detalhamento-contas-a-Receber', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, ultimoDia, select, selectClientes) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = ultimoDia
        this.select = select
        this.selectClientes = selectClientes

        this.showContasReceberDadosDelhamento()
      },

      async showContasReceberDadosDelhamento () {
        this.loading = true
        this.dadosDetalhamento = []

        await ContasReceber.showDadosDelhamento(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            this.dadosDetalhamento = resposta.data.dadosExibicao.map((item) => {
              var listaDetalhamento = ({
                categoria: item.categoria,
                subcategoria: item.subcategoria,
                total: parseFloat(item.total).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                pago: parseFloat(item.pago).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                aberto: parseFloat(item.aberto).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaDetalhamento
            })
          } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
            this.dadosDetalhamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 395px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
